module.exports={
  "name": "sparqlblocks",
  "version": "0.3.17",
  "description": "Building SPARQL queries through block programming",
  "main": "src/index.js",
  "directories": {
    "test": "tests"
  },
  "scripts": {
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/miguel76/SparqlBlocks.git"
  },
  "author": "Miguel Ceriani <miguel.ceriani@gmail.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/miguel76/SparqlBlocks/issues"
  },
  "homepage": "https://sparqlblocks.org",
  "devDependencies": {
    "aliasify": "^2.0.0",
    "brfs": "^1.5.0",
    "browserify": "^13.0.0",
    "exposify": "^0.5.0",
    "fs": "0.0.2",
    "gulp": "^3.9.1",
    "gulp-bower": "0.0.13",
    "gulp-insert": "^0.5.0",
    "gulp-remote-src": "^0.4.1",
    "gulp-rename": "^1.2.2",
    "gulp-replace": "^0.5.4",
    "gulp-ruby-sass": "^2.0.6",
    "gulp-sourcemaps": "^2.6.4",
    "gulp-uglify": "^1.5.3",
    "gulp-util": "^3.0.7",
    "gulp-xslt": "^2.0.0",
    "pathmodify": "^0.5.0",
    "vinyl-buffer": "^1.0.1",
    "vinyl-fs": "^2.4.3",
    "vinyl-source-stream": "^1.1.2"
  },
  "dependencies": {
    "blob-polyfill": "^1.0.20150320",
    "browser-filesaver": "^1.1.1",
    "clipboard": "^1.5.10",
    "jquery": "^3.3.1",
    "js-md5": "^0.4.1",
    "octicons": "^3.5.0",
    "primer-css": "^3.0.1",
    "socket.io-client": "^1.4.8",
    "underscore": "^1.8.3",
    "url-parse": "^1.1.8",
    "uuid": "^2.0.3"
  },
  "browser": {
    "blockly": "./src/import/blockly.js"
  },
  "jshintConfig": {
    "browserify": true,
    "browser": true
  }
}
